<template>
  <hm-content title="">
    <div class="flex flex-between mb10">
      <div>
        当前供货商: <span class="primary">{{ storeNames }}</span>
      </div>
      <div>
        <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入商品名称/条码"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          clearable
          size="small"
          class="mr10"
          filterable
          v-model="searchCondition.hemiaoBrandId"
          placeholder="请选择商品品牌"
        >
          <el-option
            :label="v.brandName"
            :value="v.hemiaoBrandId"
            v-for="(v, i) in hemiaoBrandBoxList"
            :key="i"
          ></el-option>
        </el-select>

        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table-panel flex flex-between item-center">
      <div>
        <el-button type="primary" size="small" @click="addGoods" class="mr10"
          >添加商品</el-button
        >
        <el-popover
          placement="top-start"
          trigger="hover"
          width="200"
          title="仅同步无图片商品"
          content="根据商品条码，在系统内寻找相同条码且有图片的商品，把图片同步到现有供货商商品维护列表下的相同商品且没有图片的商品里。"
        >
          <el-button
            slot="reference"
            type="text"
            size="small"
            class="mr10"
            @click="asyncImg('only_empty_pic')"
            >[仅同步无图片商品]</el-button
          >
        </el-popover>
        <el-popover
          placement="top-start"
          trigger="hover"
          width="200"
          title="同步（更新）全部商品图片"
          content="全部商品图片同步一次，不管商品当前是否有图片，对已有的图片进行替换。"
        >
          <el-button
            slot="reference"
            class="mr10"
            type="text"
            size="small"
            @click="asyncImg('all_pic')"
            >[同步(更新)全部商品图片]</el-button
          >
        </el-popover>
        <el-popover
          placement="top-start"
          trigger="hover"
          width="200"
          title="删除全部商品图片"
          content="一键删除全部商品图片。"
        >
          <el-button
            slot="reference"
            class="mr10"
            type="text"
            size="small"
            @click="asyncImg('del_pic')"
            >[删除全部商品图片]</el-button
          >
        </el-popover>
      </div>
      <div class="flex flex-end" style="marginbottom: -20px">

        <div class="delete mr20 pointer open-file" @click="output1">
          <span class="delete-icon hmicon icon-daoru"></span>
          商品导出
          <input
              type="file"
              style="pointer-events: none;"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>

        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          批量添加商品系列
          <input
              type="file"
              @change="batchEditGoodsSeries"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          批量修改商品名称
          <input
              type="file"
              @change="batchEditGoodsName"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
          <!-- <span class="delete-icon hmicon icon-daoru"></span> -->
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          批量修改商品价格
          <input
              type="file"
              @change="batchEditGoodsPrice"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
        <div @click="outputExcel" class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入商品
          <input
            type="file"
            @change="importf"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
           <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入商品货号
          <input
            type="file"
            @change="importf($event,'goodsSn')"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
    </div>
    <!-- <div class="flex flex-between mb10">
      <div>
        添加商品
        <el-input
          clearable
          style="width:200px;"
          v-model.trim="addGood.goodsName"
          placeholder="请输入商品名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width:200px;"
          v-model.trim="addGood.goodsBarcode"
          placeholder="请输入商品条码"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          clearable
          size="small"
          class="mr10"
          v-model="addGood.hemiaoBrandId"
          filterable
          placeholder="请选择商品品牌"
        >
          <el-option
            :label="v.brandName"
            :value="v.hemiaoBrandId"
            v-for="(v, i) in hemiaoBrandBoxList"
            :key="i"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          plain
          size="small"
          :disabled="
            addGood.goodsName === '' ||
              addGood.goodsBarcode === '' ||
              addGood.hemiaoBrandId === ''
          "
          @click="addMerchandise"
          >+ 添加</el-button
        >
      </div>
      <div class="flex item-center">
        <span @click="batchDelete" class="pointer">
          <span class="delete-icon hmicon icon-shanchu"></span>批量删除
        </span>
      </div>
    </div> -->
    <div class="table">
      <el-table
        stripe
        ref="roleTable"
        :data="supplierGoodsInfoList.records"
        @selection-change="getChecked"
        style="width: 100%"
        id="table"
        size="small"
        border
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          label="商品品牌"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsName"
          label="商品名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="商品品类"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsSn"
          label="商品货号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsBarcode"
          label="商品条码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="salePrice"
          label="销售价格"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="goodsSn"
          label="商品货号"
        ></el-table-column> -->
        <el-table-column
          prop="goodsPic"
          header-align="center"
          align="center"
          label="商品图片"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-image
                style="width: 100px; height: 100px; background: #f5f7fa"
                :src="scope.row.goodsPic"
                class="flex item-center flex-center"
                :preview-src-list="[scope.row.goodsPic]"
              >
                <!-- <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div> -->
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="商品添加时间"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                @click="edit(scope.row)"
                class="primary"
                type="text"
                >编 辑</el-button
              >
              <el-button
                size="small"
                @click="remove(scope.row)"
                class="danger"
                type="text"
                >删 除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="supplierGoodsInfoList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      custom-class="sales-volumn-dialog"
      width="1000px"
    >
      <el-dialog
        width="500px"
        title="新增品类"
        :visible.sync="innerVisible"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-form
          ref="ruleFormCategory"
          :model="ruleFormCategory"
          :rules="rulesCategory"
          label-width="100px"
        >
          <el-form-item label="类目层级">
            <el-radio-group
              v-model="ruleFormCategory.level"
              @change="switchLevel"
            >
              <el-radio label="parent">一级类目</el-radio>
              <el-radio label="child">子类目</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="类目名称" prop="categoryName">
            <el-input
              style="width: 230px"
              v-model.trim="ruleFormCategory.categoryName"
              maxlength="20"
              size="small"
              placeholder="请输入单行文本，限制20个字符"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="上级类目"
            v-if="ruleFormCategory.level === 'child'"
          >
            <el-cascader
              ref="cascader"
              v-model="ruleFormCategory.categoryId"
              :props="props"
              :show-all-levels="false"
              size="small"
            ></el-cascader>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button
            size="small"
            type="primary"
            @click="save"
            :disabled="
              !ruleFormCategory.categoryId.length &&
                ruleFormCategory.level === 'child'
            "
            >确 定</el-button
          >
          <el-button size="small" @click="innerVisible = false"
            >取 消</el-button
          >
        </span>
      </el-dialog>

      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="商品品牌" prop="hemiaoBrandId">
          <el-select
            clearable
            size="small"
            class="mr10"
            v-model="ruleForm.hemiaoBrandId"
            filterable
            placeholder="请选择商品品牌"
            :disabled="type === 'edit'"
            @change="hemiaoBrandIdChange"
          >
            <el-option
              :label="v.brandName"
              :value="v.hemiaoBrandId"
              v-for="(v, i) in allHemiaoBrandBoxList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="商品系列"
          prop="seriesId"
          v-if="ruleForm.hemiaoBrandId"
        >
          <el-select
            clearable
            size="small"
            class="mr10"
            v-model="ruleForm.seriesId"
            filterable
            placeholder="请选择商品系列"
          >
            <el-option
              :label="v.seriesName"
              :value="v.seriesId"
              v-for="(v, i) in allSeriesList"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="商品名称" prop="goodsName">
          <el-input
            clearable
            v-model.trim="ruleForm.goodsName"
            :style="ruleForm.goodsName.length > 12?'width: 350px':'width: 220px'"
            size="small"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>

        <el-form-item label="商品条码" prop="goodsBarcode">
          <el-input
            clearable
            :disabled="type === 'edit'"
            v-model.trim="ruleForm.goodsBarcode"
            maxlength="33"
            size="small"
            placeholder="请输入商品条码"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品货号" prop="goodsSn">
          <el-input
            clearable
            :disabled="type === 'edit' && goodsSnDisabled"
            v-model.trim="ruleForm.goodsSn"
            maxlength="33"
            size="small"
            placeholder="请输入商品货号"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="销售价格" prop="salePrice">
          <el-input
            clearable
            v-model.trim="ruleForm.salePrice"
            size="small"
            placeholder="请输入销售价格"
            @input="filterGt0OrFixed2('salePrice')"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="学习词表达式" prop="keyWordList" v-if="type == 'edit'">
          <div class="keyWordBox">
            <!-- 左边列表 -->
            <div class="keyWordListBox" v-if="Array.isArray(ruleForm.combinationKeywords) && ruleForm.combinationKeywords.length">
              <div class="keyWordLeftBox"
               v-for="(item, index) in ruleForm.combinationKeywords" 
               :key="index"
               @dragover.prevent
                @drop="handleDrop(index, $event)">
                    <el-tag
                    :key="i"
                    v-for="(tag, i) in item"
                    closable
                    :color="copyKeyWordList.indexOf(tag)>-1?'#fce6f0':'#fff'"
                    :disable-transitions="false"
                    @close="removeTag(index,i)"
                    >{{ tag }}</el-tag
                  >
                  <el-input
                    class="input-new-tag"
                    v-if="inputTagVisible[index]"
                    v-model.trim="newTagInput[index]"
                    ref="newSaveTagInput"
                    size="small"
                    maxlength="10"
                    clearable
                    placeholder="请输入标签，在10个汉字以内"
                    @keyup.enter.native="newHandleInputConfirm(index)"
                    @blur="newHandleInputConfirm(index)"
                  ></el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="newShowInput(index)"
                    >+ 新学习词</el-button
                  >
                  <div class="tagGroupRemoveIcon" v-if="index > 0">
                      <div class="pointer" @click="removeTagGroup(index)">
                        <span class="hmicon icon-shanchu primary"></span>
                      </div>
                </div>
              </div>
              <div class="addTagGroupIcon" @click="addTagGroup">+</div>
            </div>
            <!-- 右边列表 -->
            <div class="keyWordRight">
              <div class="keyWordRightBoxTitle">系统分词</div>
              <div class="keyWordLeftBox keyWordRightBox">
                  <div  
                    v-for="tag in ruleForm.keyWordList"
                    :key="tag" 
                    draggable="true"
                    class="tagRightBox"
                    @dragstart="handleDragStart(tag)">
                    {{tag}}</div>
              </div>
            </div>
          </div>
          
        </el-form-item>

        <el-form-item label="商品关键字" prop="keyWord">
          <el-tag
            :key="i"
            v-for="(tag, i) in ruleForm.keyWord"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
            >{{ tag }}</el-tag
          >
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model.trim="inputValue"
            ref="saveTagInput"
            size="small"
            maxlength="10"
            clearable
            placeholder="请输入标签，在10个汉字以内"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          ></el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
            >+ 新标签</el-button
          >
          <el-button
            size="small"
            @click="queryGetGoodsKeyWord"
            class="primary"
            type="text"
            >获取关键字</el-button
          >
        </el-form-item>
        <el-form-item label="商品类目" v-if="flag">
          <el-cascader
            ref="categoryName"
            v-model="ruleForm.categoryId"
            :props="props"
            :show-all-levels="false"
            size="small"
            class="mr10"
          ></el-cascader>
          <el-button
            size="small"
            @click="addCategory"
            class="primary"
            type="text"
            >新增品类</el-button
          >
        </el-form-item>
        <el-form-item label="商品图片" prop="goodsPic">
          <el-upload
            class="upload flex"
            ref="eluploadMainPic"
            :limit="1"
            drag
            :data="{ fileDir: 'mall' , targetWidth : '1000', targetHeight : '1000', bizType : 'redAddProductImg'}"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadCdnUrl"
            :onSuccess="uploadMainPicSucc"
            :beforeUpload="beforeUpload"
            :onProgress="uploading"
            :show-file-list="uploadShow"
            v-if="!ruleForm.goodsPic"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将图片拖到此处，或
              <em>点击上传</em>
            </div>
          </el-upload>
          <div class="priview" v-if="ruleForm.goodsPic">
            <img :src="ruleForm.goodsPic" alt="主图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="handleRemove">删除</el-button>
            </div>
          </div>
          <!-- <div class="flex upload-upload-btn">
            <div
              class="btn flex flex-column flex-center open-file"
              @click="show = true"
              v-if="!ruleForm.goodsPic"
            >
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>添加图片</span>
            </div>
            <div v-if="ruleForm.goodsPic" class="mr10 flex item-end priview">
              <img class="logo" :src="ruleForm.goodsPic" alt="logo" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </div> -->
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
      <!-- <my-upload
        field="file"
        @crop-upload-success="cropUploadSuccess"
        v-model="show"
        noCircle
        noSquare
        :noRotate="false"
        :width="200"
        :height="200"
        :headers="{ 'X-Access-Token': $token }"
        :params="{ fileDir: 'goodsCenter' }"
        :url="$uploadUrl"
        img-format="png"
      ></my-upload> -->
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="60%" title="导入失败提示">
      <div slot="title">
        <span style="lineheight: 24px; fontsize: 18px; color: #303133"
          >导入失败提示</span
        >
        <span class="danger">品牌名有误或者商品名重复或者价格不正确会导致导入失败</span>
      </div>
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errInputResult.length }}</span
            >条数据导入失败
          </div>
          <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div>
        </div>

        <el-table :data="errInputResult" border class="small-table">
          <el-table-column prop="brandName" label="商品品牌"></el-table-column>
          <el-table-column prop="seriesName" label="商品系列"></el-table-column>
          <el-table-column prop="goodsName" label="商品名称"></el-table-column>
          <el-table-column
            prop="goodsBarcode"
            label="商品条码"
          ></el-table-column>
          <el-table-column
            prop="salePrice"
            label="销售价格"
          ></el-table-column>
          <el-table-column prop="categoryName" label="商品品类"></el-table-column>
          <el-table-column prop="goodsSn" label="商品货号"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import myUpload from "vue-image-crop-upload";
import {arrayUnique2, getCookie, setCookie, unique} from "@/utils/utils";
import * as XLSX from 'xlsx/xlsx'
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: { myUpload },
  data() {
    return {
      uploadShow: true,
      isSaving: false,
      goodsSnDisabled: false,
      errInputResult: [],
      succInputResult: [],
      errValidGoods: false,
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1,
                storeCode: this.$route.query.storeCode
                // curCategoryId: this.currentRow.categoryId
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId,
                storeCode: this.$route.query.storeCode
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      ruleFormCategory: {
        categoryId: [],
        level: "parent",
        categoryName: ""
      },
      rulesCategory: {
        categoryName: {
          required: true,
          trrger: "blur",
          message: "请输入类目名"
        }
      },
      innerVisible: false,
      show: false,
      dialogVisible: false,
      inputValue: "",
      inputVisible: false,
      inputTagVisible:[],
      newTagInput:[],
      ruleForm: {
        goodsName: "",
        goodsSn: "",
        categoryId: [],
        goodsBarcode: "",
        hemiaoBrandId: "",
        seriesId: "",
        keyWord: [],
        keyWordList:[],
        combinationKeywords:[],
        goodsPic: "",
            salePrice: "",
      },
      rules: {
        goodsPic: {
          required: false,
          message: "请选择商品图片！",
          trigger: "blur"
        },
        goodsName: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur"
          },
          {
            required: true,
            max: 100,
            message: "名称不能大于100个字符",
            trigger: "blur"
          }
        ],
        goodsBarcode: [
          {
            required: true,
            message: "请输入商品条码",
            trigger: "blur"
          }
        ],
        hemiaoBrandId: [
          {
            required: true,
            message: "请选择商品品牌",
            trigger: "blur"
          }
        ],
        seriesId: [
          {
            required: false,
            message: "请选择商品系列",
            trigger: "blur"
          }
        ]
      },
      checkedRow: [],
      searchCondition: {},
      addGood: {
        goodsName: "",
        goodsBarcode: "",
        hemiaoBrandId: "",
        storeCode: this.$route.query.storeCode
      },
      currentPage: 1,
      pageSize: 10,
      storeNames: "",
      allHemiaoBrandBoxList: [],
      type: "",
      row: {},
      title: "",
      flag: true,
      allSeriesList: [],
      draggingTag: null,
      copyKeyWordList:[]
    };
  },
  computed: mapGetters(["supplierGoodsInfoList", "hemiaoBrandBoxList"]),
  watch: {},
  created() {},
  mounted() {
    this.storeNames = localStorage.getItem("storeName");
    this.getParamsCookie();
    this.queryList();
    this.$store.dispatch("queryHemiaoBrandComboBox", {
      supplierCode: this.$route.query.storeCode
    });
    this.$store.dispatch("queryAllHemiaoBrandComboBox").then(res => {
      this.allHemiaoBrandBoxList = res.result;
    });
  },
  methods: {
    async output1(){
      let params = {
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);

        await this.$store.dispatch(
          "goods_export_data_list",
          params
        );
    
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
      }, 0);



    },
    hemiaoBrandIdChange() {
      this.ruleForm.seriesId = "";
      this.querySeriesList();
    },
    async querySeriesList() {
      const { result } = await this.$store.dispatch("queryPageSeriesList", {
        hemiaoBrandId: this.ruleForm.hemiaoBrandId
      });
      this.allSeriesList = result.records;
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.ruleForm.keyWord.splice(this.ruleForm.keyWord.indexOf(tag), 1);
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.keyWord.push(inputValue);
        this.ruleForm.keyWord = unique(this.ruleForm.keyWord);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    async queryGetGoodsKeyWord() {
      if (
        this.ruleForm.goodsName !== "" &&
        this.ruleForm.hemiaoBrandId !== ""
      ) {
        let params = {
          storeCode: this.$route.query.storeCode,
          goodsName: this.ruleForm.goodsName,
          hemiaoBrandId: this.ruleForm.hemiaoBrandId
        };
        const { result } = await this.$store.dispatch(
          "getGoodsKeyWord",
          params
        );
        this.ruleForm.keyWord.push(...result);
        this.ruleForm.keyWord = unique(this.ruleForm.keyWord);
      } else {
        this.$message({
          message: " 请先填写品牌和商品名",
          type: "warning"
        });
      }
    },
    // 导入excel
    importf(e,type) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];

        result.forEach(v => {
          // v[0] = v[0] ? (v[0] + "").replace(/\s*/g, "") : "";
          // v[1] = v[1] ? (v[1] + "").replace(/\s*/g, "") : "";
          // v[2] = v[2] ? (v[2] + "").replace(/\s*/g, "") : "";
          // v[3] = v[3] ? (v[3] + "").replace(/\s*/g, "") : "";
          // v[4] = v[4] ? (v[4] + "").replace(/\s*/g, "") : "";
          if (v[0] || v[1] || v[2] || v[3] || v[4] || v[5] || v[6]) {
            formatResult.push({
              brandName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              seriesName: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              goodsName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
              goodsBarcode: v[3] ? (v[3] + "").replace(/[^\w]/g, "") : "",
              salePrice: v[4] ? (v[4] + "").replace(/\s*/g, "") : "",
              categoryName: v[5] ? (v[5] + "").replace(/\s*/g, "") : "",
              goodsSn: v[6] ? (v[6] + "").replace(/\s*/g, "") : "",
              storeCode: that.$route.query.storeCode
            });
          }
        });
        // formatResult = arrayUnique2(formatResult, "goodsSn");
        // goodsSns = formatResult.map(o => o.goodsSn);
        let requestType = ''
        if(type === 'goodsSn') {
          requestType = 'batchEditGoodsSn'
        }else {
          requestType = 'exportGoodsSupplier'
        }
        that.$store.dispatch(requestType, formatResult).then(res => {
          const { code, result } = res;
          if (code === "0") {
            if (result.failList.length) {
              that.errValidGoods = true;
              that.errInputResult = result.failList;
              that.$message({
                message: "部分商品导入失败！",
                type: "warning"
              });
            }
            that.succInputResult = result.successList;
            that.queryList();
          }
        });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导入excel批量修改商品名
    batchEditGoodsName(e) {
      console.log(e);
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];

        result.forEach(v => {
          if (v[2] && v[3]) {
            formatResult.push({
              brandName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              seriesName: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              goodsName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
              goodsBarcode: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
              salePrice: v[4] ? (v[4] + "").replace(/\s*/g, "") : "",
              storeCode: that.$route.query.storeCode
            });
          }
        });
        that.$store.dispatch("batchEditGoodsNameSupplier", formatResult).then(res => {
          const { code, result } = res;
          if (code === "0") {
            if (result.failList.length) {
              that.errValidGoods = true;
              that.errInputResult = result.failList;
              that.$message({
                message: "部分商品导入失败！",
                type: "warning"
              });
            } else {
              that.$message({
                message: "操作成功！",
                type: "success"
              });
            }
            that.succInputResult = result.successList;
            that.queryList();
          }
        });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导入excel批量修改商品价格
    batchEditGoodsPrice(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
    
        result.forEach(v => {
          if (v[3]) {
          let salePrices;
          if(v[4] !=0){
            salePrices = v[4] ? (v[4] + "").replace(/\s*/g, "") : "";
          }else {
            salePrices = v[4];
          }
            formatResult.push({
              goodsBarcode: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
              salePrice: salePrices,
              storeCode: that.$route.query.storeCode
            });
          }
        });
        that.$store.dispatch("batchEditGoodsPriceSupplier", formatResult).then(res => {
          const { code, result } = res;
          if (code === "0") {
            if (result.failList.length) {
              that.errValidGoods = true;
              that.errInputResult = result.failList;
              that.$message({
                message: "部分商品导入失败！",
                type: "warning"
              });
            } else {
              that.$message({
                message: "操作成功！",
                type: "success"
              });
            }
            that.succInputResult = result.successList;
            that.queryList();
          }
        });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导入excel批量添加商品系列
    batchEditGoodsSeries(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];

        result.forEach(v => {
          if (v[2]) {
            formatResult.push({
              brandName: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
              seriesName: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
              goodsName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
              goodsBarcode: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
              storeCode: that.$route.query.storeCode
            });
          }
        });

        formatResult = arrayUnique2(formatResult, "goodsName");

        that.$store.dispatch("batchEditGoodsSeriesSupplier", formatResult).then(res => {
          const { code, result } = res;
          if (code === "0") {
            if (result.failList.length) {
              that.errValidGoods = true;
              that.errInputResult = result.failList;
              that.$message({
                message: "部分商品导入失败！",
                type: "warning"
              });
            } else {
              that.$message({
                message: "操作成功！",
                type: "success"
              });
            }
            that.succInputResult = result.successList;
            that.queryList();
          }
        });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品品牌(必填)", "商品系列", "商品名称(必填)", "商品条码(必填)", "销售价", "商品品类", "商品货号"];
        const data = [];
        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    resetRuleFormCategory() {
      setTimeout(() => {
        this.$refs.ruleFormCategory.resetFields();
      }, 0);
    },
    save() {
      this.$refs.ruleFormCategory.validate(valid => {
        if (valid) {
          // const categoryLevel =
          //   this.ruleForm.level === "parent" ? "1" : this.level;
          let parentCategoryId = this.ruleFormCategory.categoryId[
            this.ruleFormCategory.categoryId.length - 1
          ];

          let params = {
            categoryName: this.ruleFormCategory.categoryName,
            parentCategoryId,
            storeCode: this.$route.query.storeCode
          };
          this.$store.dispatch("addGoodsCategory", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.innerVisible = false;
              this.resetRuleFormCategory();
              this.flag = false;
              setTimeout(() => {
                this.flag = true;
              }, 0);
              this.$store.commit("QUERY_GOOD_CATEGORY_LIST", {
                result: { record: [] }
              });
              // this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    switchLevel() {
      this.ruleFormCategory.categoryId = [];
    },
    addCategory() {
      this.innerVisible = true;
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      //   const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      //   if (!limitSize) {
      //     this.$message({
      //       message: "上传模板大小不能超过 1M!",
      //       type: "warning"
      //     });
      //   }
      return extension || extension2 || extension3 || extension4;
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
      this.isSaving = false;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.goodsPic = jsonData.result;
        this.uploadShow = false;
      }
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
        this.ruleForm.categoryId = "";
      }, 0);
    },
    // 移除上传文件
    handleRemove() {
      this.ruleForm.goodsPic = "";
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: this.$route.query.storeCode
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      this.setParamsCookie();
      return this.$store.dispatch("querySupplierGoodsInfoList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "redpackageGoodsListParamsNew" + this.$route.query.storeCode,
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "redpackageGoodsListParamsNew" + this.$route.query.storeCode, type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.supplierGoodsId);
    },
    batchDelete() {
      if (this.checkedRow.length) {
        let say = "删除已选" + this.checkedRow.length + "条数据";
        this.$confirm(say, "提示", {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning"
        }).then(() => {
          let params = { supplierGoodsIds: this.checkedRow };
          this.$store.dispatch("delSupplierGoodsInfo", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.queryList();
            }
          });
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    confirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.goodsName = this.ruleForm.goodsName.replace("（", "(").replace("）", ")");
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          params.storeCode = this.$route.query.storeCode;

          params.categoryId =
            params.categoryId && params.categoryId.length > 0
              ? params.categoryId[params.categoryId.length - 1]
              : "";
          params.keyWord =
            params.keyWord.length > 0 ? params.keyWord.join(",") : null;
          let name =
            this.type === "add"
              ? "saveSupplierGoodsInfoList"
              : "editSupplierGoodsInfoById";
          if (this.type === "edit") {
            params.supplierGoodsId = this.row.supplierGoodsId;
            params.combinationKeywords = JSON.stringify(params.combinationKeywords);
          }else {
            // 非编辑类型时删除这两个字段
              delete params.combinationKeywords;
              delete params.keyWordList;
          }
          return this.$store.dispatch(name, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });

              this.resetRuleForm();

              this.queryList();
              this.dialogVisible = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // addMerchandise() {
    //   this.addGood.storeCode = this.$route.query.storeCode;
    //   return this.$store
    //     .dispatch("saveSupplierGoodsInfoList", this.addGood)
    //     .then(res => {
    //       if (res.code === "0") {
    //         this.$message({
    //           message: " 操作成功",
    //           type: "success"
    //         });
    //         this.queryList();
    //         this.addGood = {};
    //       }
    //     });
    // },
    async asyncImg(syncPicType) {
      const { code, result } = await this.$store.dispatch("syncGoosImg", {
        syncPicType,
        storeCode: this.$route.query.storeCode
      });
      if (code === "0") {
        this.$message({
          message: `操作成功，更新${result.updateNum}条数据！`,
          type: "success"
        });
        this.queryList();
      }
    },
    addGoods() {
      this.title = "添加商品";
      this.type = "add";
      this.dialogVisible = true;
      this.resetRuleForm();
    },
  async getGoodsKeyWordList(row) {
    const params = { supplierGoodsId: row.supplierGoodsId };
    const res = await this.$store.dispatch('getGoodsKeyWordList', params);
    return res.result || [];
  },
    async edit(row) {
      this.title = "编辑商品";
      this.type = "edit";
      this.row = row;
      this.dialogVisible = true;
      const { result } = await this.$store.dispatch("detailsSupplierGoods", {
        supplierGoodsId: row.supplierGoodsId
      });
      for (let key in this.ruleForm) {
        this.ruleForm[key] = result[key];
      }
      this.ruleForm.keyWordList = await this.getGoodsKeyWordList(row);
      this.copyKeyWordList = JSON.parse(JSON.stringify(this.ruleForm.keyWordList));
      if(this.ruleForm.combinationKeywords) {
          this.ruleForm.combinationKeywords = JSON.parse(result.combinationKeywords);
          // 新增逻辑：过滤掉已存在于 combinationKeywords 中的 keyWordList 标签
          const allTagsInGroups = this.ruleForm.combinationKeywords.flat();
          this.ruleForm.keyWordList = this.ruleForm.keyWordList.filter(
            tag => !allTagsInGroups.includes(tag)
          );
           this.initInputArrays()
      }else {
        this.ruleForm.combinationKeywords = []
        this.addTagGroup()
      }
      if (this.ruleForm.goodsSn) {
        this.goodsSnDisabled = true;
      } else {
        this.goodsSnDisabled = false;
      }
      if (result.keyWord) {
        this.ruleForm.keyWord =
          result.keyWord.length === 1
            ? [result.keyWord]
            : result.keyWord.split(",");
      } else {
        this.ruleForm.keyWord = [];
      }
      if (this.ruleForm.hemiaoBrandId) {
        this.querySeriesList();
      }

      setTimeout(() => {
        if (this.$refs.categoryName) {
          this.$refs.categoryName.inputValue = row.categoryName;
        }
      }, 0);

      this.ruleForm.categoryId = [result.categoryId];
    },
    remove(row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        let params = { supplierGoodsIds: [row.supplierGoodsId] };
        this.$store.dispatch("delSupplierGoodsInfo", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    initInputArrays() {
      this.inputTagVisible = this.ruleForm.combinationKeywords.map(() => false);
      this.newTagInput = this.ruleForm.combinationKeywords.map(() => '');
    },
    newShowInput(index) {
      this.$set(this.inputTagVisible, index, true);
      this.$nextTick(() => {
        const refs = this.$refs.newSaveTagInput;
        if (Array.isArray(refs) && refs[index]) {
          const inputElm = refs[index].$el ? refs[index].$el.querySelector('input') : refs[index];
          if (inputElm && inputElm.focus) {
            inputElm.focus();
          }
        }
      });
    },
     newHandleInputConfirm(index) {
        // const value = this.newTagInput[index];
        // if (value) {
        //   // 判断是否已存在
        //   if (!this.ruleForm.combinationKeywords[index].includes(value)) {
        //     this.ruleForm.combinationKeywords[index].push(value);
        //   } else {
        //     // this.$message.warning("该标签已存在");
        //   }
        //   this.newTagInput[index] = '';
        // }
        // this.$set(this.inputTagVisible, index, false);    
        
         const value = this.newTagInput[index];
          if (value) {
            // 全局查找是否存在
            const isExist = this.ruleForm.combinationKeywords.some(group => group.includes(value));
            if (!isExist) {
              this.ruleForm.combinationKeywords[index].push(value);
            } else {
              this.$message.warning('该标签已存在');
            }
            this.newTagInput[index] = '';
          }
          this.$set(this.inputTagVisible, index, false);
      },
       removeTag(parentIndex, childIndex) {
         const tag = this.ruleForm.combinationKeywords[parentIndex][childIndex];
        this.ruleForm.combinationKeywords[parentIndex].splice(childIndex, 1);
        // 检查是否来自 copyKeyWordList 且不再存在于 keyWordList 中
        if (
          this.copyKeyWordList.includes(tag) &&
          !this.ruleForm.keyWordList.includes(tag)
        ) {
          this.ruleForm.keyWordList.push(tag);
        }
      },
      addTagGroup() {
        this.ruleForm.combinationKeywords.push([]);
        this.inputTagVisible.push(false);
        this.newTagInput.push('');
      },
      removeTagGroup(index) {
         const removedGroup = this.ruleForm.combinationKeywords[index];

          // 遍历被删除的标签组中的每一个标签
          removedGroup.forEach(tag => {
            // 如果 tag 存在于 copyKeyWordList 但 不在 keyWordList 中
            if (
              this.copyKeyWordList.includes(tag) &&
              !this.ruleForm.keyWordList.includes(tag)
            ) {
              this.ruleForm.keyWordList.push(tag);
            }
          });

          // 删除对应的组合标签组
          this.ruleForm.combinationKeywords.splice(index, 1);
      },
      handleDragStart(tag) {
        this.draggingTag = tag;
        // console.log(tag,5555666);
      },
      handleDrop(groupIndex, event) {
        // console.log(event,898898);
        // if (this.draggingTag) {
        //   const targetGroup = this.ruleForm.combinationKeywords[groupIndex];
        //   if (!targetGroup.includes(this.draggingTag)) {
        //     targetGroup.push(this.draggingTag);
        //   }
        //   this.draggingTag = null;
        // }
         if (this.draggingTag) {
          const isExistInAll = this.ruleForm.combinationKeywords.some(group =>
            group.includes(this.draggingTag)
          );

          const targetGroup = this.ruleForm.combinationKeywords[groupIndex];

          if (!isExistInAll) {
            targetGroup.push(this.draggingTag);
             // 删除 keyWordList 中的对应标签
            const indexInKeyWordList = this.ruleForm.keyWordList.indexOf(this.draggingTag);
            if (indexInKeyWordList > -1) {
              this.ruleForm.keyWordList.splice(indexInKeyWordList, 1);
            }
          } else {
            this.$message.warning('该标签已存在');
          }

          this.draggingTag = null;
        }
      },
  }
};
</script>
<style lang="scss" scoped>
.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}
.priview {
  position: relative;
  width: 375px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priview {
  position: relative;
  .logo {
    width: 100px;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.keyWordBox {
  display: flex;
  gap: 60px;
}
.keyWordListBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

}
.keyWordLeftBox {
  position: relative;
    width: 320px;
    padding: 10px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    .tagGroupRemoveIcon {
      position: absolute;
      right: 0;
      top: -12px;
    }
}
.addTagGroupIcon {
    width: 54px;
    height: 54px; 
    border-radius: 8px 8px 8px 8px;
    text-align: center;
    line-height: 54px;
    opacity: 1;
    border: 1px dashed #e50065;
    font-size: 40px;
    color: #e50065;
    cursor: pointer;
}
.keyWordRight {
    margin-top: -20px;
    .keyWordRightBoxTitle {
    font-size: 14px;
    font-weight: bold;
    color: #606266;
  }
  .keyWordRightBox {
    min-height: 180px;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }
  .tagRightBox {
    background-color: #fce6f0;
    border-color: #facce0;
    color: #e50065;
    display: inline-block;
    height: 32px;
    padding: 0 10px;
    line-height: 30px;
    font-size: 12px;
    color: #E50065;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    box-sizing: border-box;
    white-space: nowrap;
    cursor: move;
  }
}

</style>
